import { render, staticRenderFns } from "./Tab6.vue?vue&type=template&id=7453c4f2&scoped=true"
import script from "./Tab6.vue?vue&type=script&lang=js"
export * from "./Tab6.vue?vue&type=script&lang=js"
import style0 from "./Tab6.vue?vue&type=style&index=0&id=7453c4f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7453c4f2",
  null
  
)

export default component.exports